import { Component } from '@angular/core';

@Component({
  selector: 'app-cabinas',
  templateUrl: './cabinas.component.html',
  styleUrls: ['./cabinas.component.css']
})
export class CabinasComponent {

}
